export const SupplierDetailsGetters = {
  CurrentSupplier: 'getCurrentSupplier',
  CurrentSupplierContractors: 'getSupplierContractors',
  SupplierContractorsSortOrder: 'getContractorSortOrder',
  CurrentSupplierContacts: 'getSupplierContacts',
  SupplierContactsSortOrder: 'getContactsSortOrder',
  GetSupplierAttachments: 'getSupplierAttachments'
};

export const SupplierDetailsMutations = {
  SetLoading: 'setLoading',
  UpdateSupplier: 'updateSupplier',
  ResetSupplierState: 'resetState',
  SetSupplierContractors: 'setSupplierContractors',
  SetSupplierContractorsSortOrder: 'setContractorsSortOrder',
  SetSupplierContacts: 'setSupplierContacts',
  SetSupplierContactsSortOrder: 'setContactsSortOrder',
  SetSupplierAttachments: 'setSupplierAttachments'
};

export const SupplierDetailsActions = {
  ResetCurrentSupplier: 'resetCurrentSupplier',
  RetrieveSupplier: 'retrieveSupplier',
  SaveSupplierDetails: 'saveSupplierDetails',
  RetrieveSupplierContractors: 'getSuppliersContractors',
  UpdateSupplierContractorSortOrder: 'updateContractorsSortOrder',
  RetrieveSupplierContacts: 'getSupplierContacts',
  UpdateSupplierContactsSortOrder: 'updateContactsSortOrder',
  RetrieveSupplierAttachments: 'retrieveSupplierAttachments'
};
